import UnidadeMedidaCadastro from '../../spa/unidade-medida/UnidadeMedidaCadastro';

export default {
  path: 'unidade-medida',
  name: 'unidade-medida',
  component: UnidadeMedidaCadastro,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/unidade-medida.js